import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";

function init() {
    $("#comment-submit").click(function() {
        try {
            if ($("#comment-text").val().length === 0) {
                $("#comment-text-val").css("visibility", "visible");
            } else {
                const data = {
                    personId: $("#personId").val(),
                    roleId: $("#roleId").val(),
                    commentText: $("#comment-text").val()
                };

                const params = {
                    "method": "POST",
                    "data": data,
                    "url": "/Person/AddComment",
                    "contentType": "application/json; charset=utf-8",
                    "successMsg": "Successfully added comment."
                };

                forms.disableSubmitButton();

                dataaccess.post(params).done(function(result) {
                    $("#add-comment-modal").modal("hide");
                    $("#comment-text").val("");
                    const comment = result.comment;
                    const commenterHighestRole = result.commenterHighestRole;

                    $("#comment-container").prepend("<div class='row border p-2'><div class='col-sm-1'>  <span class='fa-stack fa-1x'><i class='fa fa-circle fa-stack-2x' style='color: " + commenterHighestRole.displayColor + "'></i><span class='fa-stack-1x text-white circle-comment-icon'>" + comment.insertedByPerson.firstName[0].toUpperCase() + comment.insertedByPerson.lastName[0].toUpperCase() + "</span></span></div>" +
                        "<div class='col-sm-11'><p>" + comment.commentText + "</p>" +
                        "<p class='small'>By " + comment.insertedByPerson.firstName + " " + comment.insertedByPerson.lastName + " : " + commenterHighestRole.name + " on " + comment.insertedDateUtc + "</p></div></div>");
                });
            }
        } catch (e) {
            location.reload();
        }
    });
}

export const addComment = {
    init: init
};